var map = {
	"./7z.svg": "9mfx",
	"./Job_wanted.svg": "NyX9",
	"./Laboratory.svg": "fUlr",
	"./all.svg": "QcK0",
	"./archives.svg": "PZ7j",
	"./bmp.svg": "bFOf",
	"./bumen.svg": "ZEAf",
	"./car.svg": "hW6F",
	"./dashboard.svg": "BCGP",
	"./doc.svg": "F2xj",
	"./docx.svg": "t4uj",
	"./dynamics.svg": "UzQO",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fang.svg": "u2Dx",
	"./form.svg": "sTIr",
	"./gif.svg": "4DYT",
	"./gong.svg": "TDmu",
	"./item.svg": "moUN",
	"./jpeg.svg": "N7W9",
	"./jpg.svg": "ZAXH",
	"./leaving.svg": "9fqe",
	"./link.svg": "KgwQ",
	"./love.svg": "gJ+2",
	"./nested.svg": "798r",
	"./nongye.svg": "tTun",
	"./nongzi.svg": "2W39",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./png.svg": "SbqJ",
	"./position.svg": "3sTt",
	"./ppt.svg": "4hoL",
	"./prsonnels.svg": "eGML",
	"./rar.svg": "4G86",
	"./rectify.svg": "0+40",
	"./renmai.svg": "PKIg",
	"./shitang.svg": "0SL5",
	"./shuju.svg": "y9Vh",
	"./statistical.svg": "3pKd",
	"./system.svg": "Jax1",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./txt.svg": "YXXy",
	"./user.svg": "VdD3",
	"./wenhao.svg": "HXEi",
	"./wh.svg": "kedP",
	"./word.svg": "ELgs",
	"./xin.svg": "P8/x",
	"./xls.svg": "U1K1",
	"./xlsx.svg": "+EMO",
	"./yiqi.svg": "iSEn",
	"./ysb.svg": "1z9d",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 77